// extracted by mini-css-extract-plugin
export default {"headOrange":"FeeExplanation_headOrange__9tpJq","row":"FeeExplanation_row__RMb6s","column":"FeeExplanation_column__NlMVD"};